import { useTranslation } from 'react-i18next';
import ToastProvider from './ui/toast/ToastProvider';

// The app's toast layer. ui/ components take their strings as props, so the
// layer's one string -- the close button's accessible name -- is translated
// here rather than inside ui/toast/.
export default function AppToastProvider({ children }) {
  const { t } = useTranslation('common');
  return <ToastProvider dismissLabel={t('buttons.close')}>{children}</ToastProvider>;
}
